import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function RunningAgenticWorkflow() {

    return (
        <div>
            <DHeader>Setting up the Agent</DHeader>

            <DCode>
            {`input_data= {
    "text": "Im AV. Can you send me 2 packets milk, noodles 1 packet, bread 1 packet, coffee 1 packet, apples 2"
}

output = flow.run(input_data)

print("Final Output:", output)

for key, value in output.items():
    print("------------------",key,"------------------------")
    print("\n")
    print(value)
            
            `}

            </DCode>
       
          
       
        </div>
    )
}